// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-title.blue {
  color: #0074b3 !important;
}

.button_boring_red.blue {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  margin: 2px;
  background-color: #0074b3 !important;
  color: white;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  font-weight: normal;
  text-transform: uppercase;
  padding: 1rem 1rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  line-height: 1.2;
  min-height: 120px;
}

.button_boring_red.blue:hover {
  background-color: #005f94 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease, transform 0.2s ease;
}


.button_boring_red .material-symbols-outlined {
  font-size: 2rem;
  color: white;
}

.button_boring_red .sparkasse-icon {
  width: 1.8rem;
  height: 1.8rem;
  max-width: none;
  object-fit: contain;
}

@media (max-width: 768px) {
  .button-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .section-title.blue {
    font-size: 2.5rem !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/listen/Listen.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;EACzC,2DAA2D;AAC7D;;;AAGA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".section-title.blue {\n  color: #0074b3 !important;\n}\n\n.button_boring_red.blue {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin: 2px;\n  background-color: #0074b3 !important;\n  color: white;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  padding: 1rem 1rem;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  text-align: left;\n  line-height: 1.2;\n  min-height: 120px;\n}\n\n.button_boring_red.blue:hover {\n  background-color: #005f94 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n\n.button_boring_red .material-symbols-outlined {\n  font-size: 2rem;\n  color: white;\n}\n\n.button_boring_red .sparkasse-icon {\n  width: 1.8rem;\n  height: 1.8rem;\n  max-width: none;\n  object-fit: contain;\n}\n\n@media (max-width: 768px) {\n  .button-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .section-title.blue {\n    font-size: 2.5rem !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
